import { forwardRef } from 'react';

import { IconProps } from './icons.types';

import { SvgStyled } from './icons.styles';

export const ClockIcon = forwardRef<SVGSVGElement, IconProps>(function ClockIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M6 11.9341C2.7266 11.9341 0.065934 9.2734 0.065934 6C0.065934 2.7266 2.7266 0.065934 6 0.065934C9.2734 0.065934 11.9341 2.7266 11.9341 6C11.9341 9.2734 9.2734 11.9341 6 11.9341ZM6 0.893943C3.18477 0.893943 0.893943 3.18477 0.893943 6C0.893943 8.81523 3.18477 11.1061 6 11.1061C8.81523 11.1061 11.1061 8.81523 11.1061 6C11.1061 3.18477 8.81523 0.893943 6 0.893943Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M7.87377 8.30769C7.80545 8.30769 7.73712 8.29043 7.67406 8.24442L6.04488 7.18027C5.64022 6.91567 5.34066 6.3347 5.34066 5.82276V3.46438C5.34066 3.22854 5.51934 3.03297 5.73482 3.03297C5.95029 3.03297 6.12897 3.22854 6.12897 3.46438V5.82276C6.12897 6.02984 6.28663 6.3347 6.44955 6.43824L8.07873 7.50239C8.26792 7.62319 8.32573 7.88778 8.21537 8.09486C8.13654 8.23291 8.00515 8.30769 7.87377 8.30769Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0.131868C2.76302 0.131868 0.131868 2.76302 0.131868 6C0.131868 9.23698 2.76302 11.8681 6 11.8681C9.23698 11.8681 11.8681 9.23698 11.8681 6C11.8681 2.76302 9.23698 0.131868 6 0.131868ZM0 6C0 2.69019 2.69019 0 6 0C9.30981 0 12 2.69019 12 6C12 9.30981 9.30981 12 6 12C2.69019 12 0 9.30981 0 6ZM0.828009 6C0.828009 3.14835 3.14835 0.828009 6 0.828009C8.85164 0.828009 11.172 3.14835 11.172 6C11.172 8.85164 8.85164 11.172 6 11.172C3.14835 11.172 0.828009 8.85164 0.828009 6ZM6 0.959877C3.22118 0.959877 0.959877 3.22118 0.959877 6C0.959877 8.77882 3.22118 11.0401 6 11.0401C8.77882 11.0401 11.0401 8.77882 11.0401 6C11.0401 3.22118 8.77882 0.959877 6 0.959877ZM5.73482 3.0989C5.56124 3.0989 5.40659 3.25922 5.40659 3.46438V5.82276C5.40659 6.31428 5.69641 6.87364 6.08097 7.12509L7.71298 8.19108C7.76308 8.22764 7.81718 8.24176 7.87377 8.24176C7.9792 8.24176 8.08945 8.18178 8.15763 8.06301C8.25311 7.88285 8.19989 7.65798 8.04325 7.55796L8.04267 7.55759L6.41419 6.49389C6.31899 6.43326 6.23195 6.31961 6.16966 6.19973C6.10703 6.0792 6.06304 5.94055 6.06304 5.82276V3.46438C6.06304 3.25922 5.90839 3.0989 5.73482 3.0989ZM5.27472 3.46438C5.27472 3.19786 5.47745 2.96703 5.73482 2.96703C5.99218 2.96703 6.1949 3.19786 6.1949 3.46438V5.82276C6.1949 5.91205 6.22974 6.02937 6.28667 6.13893C6.34387 6.249 6.41732 6.33964 6.48492 6.38259L6.48561 6.38304L8.11421 7.44682C8.33549 7.58831 8.39814 7.89211 8.27355 8.12587L8.27265 8.12757C8.18312 8.28435 8.03085 8.37363 7.87377 8.37363C7.79421 8.37363 7.71226 8.35341 7.63663 8.29872L6.00883 7.23547C5.58405 6.95772 5.27472 6.35512 5.27472 5.82276V3.46438Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
